import { NavLink, Outlet } from "react-router-dom";

const AccountTab = () => {
  return (
    <>
      <nav>
        <NavLink to="/login"></NavLink>
      </nav>
      <main>
        <Outlet />
      </main>
    </>
  );
};

export default AccountTab;
